(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[747],{

/***/ 2247:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brighton/seo-design-portfolio/web-design-west-sussex",
      function () {
        return __webpack_require__(6933);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_blocks_portfolio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(362);
/* harmony import */ var components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9472);
/* harmony import */ var components_common_SEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2034);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4870);
/* harmony import */ var components_common_ProjectDetailsNavigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4153);
/* harmony import */ var components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9266);


// -------- custom component -------- // 






var details = {
    pageName: "Miguel Madeira Music",
    categories: "wordpress, web services",
    description: "Miguel Madeira Music is a music composer, arranger and producer. We were asked to design and develop a new website for him. We also provided SEO services.",
    parentDirectories: "seo-design-portfolio"
};
var Portfolio = data_keywords__WEBPACK_IMPORTED_MODULE_5__.LocalSEOArrays[8].keywords;
var ProjectDetails = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_SEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        title: "".concat(Portfolio[0].title, " - ").concat(details.pageName),
                        description: details.description,
                        tag: details.categories,
                        urlPT: "",
                        urlENPT: "",
                        url: "".concat(Portfolio[0].url, "/").concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-")),
                        image: "/img/clients/".concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "wrapper image-wrapper bg-image bg-overlay text-white",
                        style: {
                            backgroundImage: "url(/img/clients/" + Portfolio[1].title.toLowerCase().replace(/ /g, "-") + "-bg.jpg)",
                            backgroundSize: "cover"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container pt-17 pb-12 pt-md-19 pb-md-16 text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-md-10 mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "post-header",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                className: "fs-15 text-uppercase text-white mb-3",
                                                children: Portfolio[0].title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "display-4 text-capitalize mx-auto",
                                                children: details.pageName
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "wrapper bg-light wrapper-border",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container pt-14 pt-md-16 pb-13 pb-md-15",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-lg-12 offset-lg-0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "display-6 mb-4",
                                            children: details.pageName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "col-md-8 text-justify",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                className: "caption",
                                                                children: details.description
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            children: [
                                                                "Miguel Madeira is a talented musician with a passion for delivering quality music services to media agencies and film companies. He approached SEOptimist ",
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                    title: data_keywords__WEBPACK_IMPORTED_MODULE_5__.HomeList[2].title,
                                                                    href: "/"
                                                                }),
                                                                " with a goal of creating a website that reflected his unique style and brand. At SEOptimist web design West Sussex, we were happy to assist him in achieving his goal by providing a custom WordPress web design."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                            children: Portfolio[1].title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Our team of skilled web designers and developers worked closely with Miguel to understand his vision and goals for the website. We started by creating a custom WordPress theme that reflected his unique style and brand. SEOptimist used the latest web design tools and techniques to ensure that the website was responsive, easy to navigate, and visually appealing."
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                            children: Portfolio[2].title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "We also customized the WordPress theme to include features that were important to Miguel, such as an audio player that allowed his fans to stream his music directly from the website. We also integrated social media widgets that made it easy for visitors to share his content on various social media platforms."
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            width: "100%",
                                                            height: "auto",
                                                            src: "/img/clients/".concat(Portfolio[2].title.toLowerCase().replace(/ /g, "-"), ".jpg"),
                                                            alt: Portfolio[2].title,
                                                            style: {
                                                                background: "transparent"
                                                            },
                                                            className: "mb-5 mw"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Our team also provided Miguel with training on how to use the WordPress content management system, allowing him to easily update the website content and add new music tracks, videos, and photos. We also provided him with ongoing support to ensure that the website was always up-to-date and running smoothly. The result was a beautiful, custom-designed WordPress website that accurately reflected Miguel's unique style and brand."
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                className: "text-dark",
                                                                title: data_keywords__WEBPACK_IMPORTED_MODULE_5__.HomeList[4].title,
                                                                href: "/"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "The code is optimised for search engines, making it easy for companies to find his music online. We undertook an SEO audit of the website and provided Miguel with a list of recommendations to improve his website's search engine ranking. We also provided him with ongoing SEO services to ensure that his website remained visible in search engine results."
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Since launching the website, Miguel has received a lot of positive feedback from his site visitors and has experienced an increase in website traffic and social media engagement."
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "At SEOptimist web design West Sussex, we're committed to delivering customized WordPress web design solutions that meet our clients' unique needs. Contact us today to learn more about our web design services and how we can help you achieve your online goals."
                                                        }),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "col-md-4 ms-auto",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            width: 275,
                                                            height: "auto",
                                                            src: "/img/clients/".concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-"), ".jpg"),
                                                            alt: Portfolio[0].title,
                                                            style: {
                                                                background: "transparent"
                                                            },
                                                            className: "mb-5"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                            className: "list-unstyled",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                            className: "mb-1",
                                                                            children: "Categories"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            children: details.categories
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                            className: "mb-1",
                                                                            children: "Client Name"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            children: details.pageName
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    title: "Get in touch",
                                                    href: "/#contact",
                                                    className: "more hover"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_portfolio__WEBPACK_IMPORTED_MODULE_2__/* .LocalSEO */ .wx, {
                                                    initialslide: 0
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ProjectDetailsNavigation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                location: "brighton"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProjectDetails);


/***/ }),

/***/ 4153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var ProjectDetailsNavigation = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "wrapper bg-light"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProjectDetailsNavigation);


/***/ }),

/***/ 9266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7702);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4870);
/* harmony import */ var hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9588);


// -------- custom component -------- //



var ContactInfoDI = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 873).then(__webpack_require__.bind(__webpack_require__, 873));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(873)
            ];
        }
    },
    ssr: false
});
var ContactFooterCombo = function(param) {
    var location = param.location;
    (0,hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "wrapper bg-light",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactInfoDI, {
                    location: location,
                    title: "Free Consultation",
                    body: "Reach out to us and we will get back to you right away with a customised plan to get you more sales.",
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__/* .Footer1 */ .gH, {
                    address: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address1,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address2,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address3
                            ]
                        })
                    ],
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactFooterCombo);


/***/ }),

/***/ 959:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var useIsotope = function() {
    var isotope = useRef();
    var ref = useState("*"), filterKey = ref[0], setFilterKey = ref[1];
    useEffect(function() {
        if (false) {}
        _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var Isotope, grids;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return __webpack_require__.e(/* import() */ 3391).then(__webpack_require__.t.bind(__webpack_require__, 3391, 23));
                    case 2:
                        Isotope = _ctx.sent.default;
                        grids = document.querySelectorAll(".grid");
                        if (grids !== null) {
                            grids.forEach(function(g) {
                                var grid = g.querySelector(".isotope");
                                isotope.current = new Isotope(grid, {
                                    itemSelector: ".item",
                                    layoutMode: "masonry",
                                    masonry: {
                                        columnWidth: grid.offsetWidth / 12
                                    },
                                    percentPosition: true,
                                    transitionDuration: "0.7s"
                                });
                            });
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
        return function() {
            var ref;
            return (ref = isotope.current) === null || ref === void 0 ? void 0 : ref.destroy();
        };
    }, []);
    useEffect(function() {
        var ref;
        var filtered = filterKey === "*" ? {
            filter: "*"
        } : {
            filter: filterKey
        };
        (ref = isotope.current) === null || ref === void 0 ? void 0 : ref.arrange(filtered);
    }, [
        filterKey
    ]);
    // change filter item
    var handleFilterKeyChange = function(key) {
        return function() {
            return setFilterKey(key);
        };
    };
    return {
        handleFilterKeyChange: handleFilterKeyChange,
        filterKey: filterKey
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useIsotope)));


/***/ }),

/***/ 2783:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var carouselBreakpoints = {
    0: {
        slidesPerView: 1
    },
    768: {
        slidesPerView: 2
    },
    1200: {
        slidesPerView: 3
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (carouselBreakpoints);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,4870,4556,6435,362,9774,2888,179], function() { return __webpack_exec__(2247); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);